import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';


@autoinject()
export class EssRibbonLink extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable()
    protected target: string | null = '_self';

    @bindable()
    protected tooltip: string | null = null;

    @bindable()
    protected url: string | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {

        super(...rest);
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
